import PropTypes from 'prop-types';

export const policeShape = {
  isEnabled: PropTypes.bool,
  serviceName: PropTypes.string,
  shortDescription: PropTypes.string,
  insuranceSum: PropTypes.number,
  number: PropTypes.string,
  downloadUrl: PropTypes.string,
  subscriptionFee: PropTypes.number,
  lastPeriodPayed: PropTypes.string,
  periods: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      datePeriodStart: PropTypes.string,
      datePeriodEnd: PropTypes.string,
    }),
  ),
  splId: PropTypes.number,
  presetId: PropTypes.string,
};
